import React from "react";
import { useLang } from "../LangContext";
import { useReveal } from "../hooks/useReveal";
import { Flame, Wand2, Sparkles } from "lucide-react";

const icons = [Flame, Wand2, Sparkles];
const accents = [
  { ring: "ring-orange-500/40", glow: "glow-orange", grad: "from-orange-500 to-amber-400" },
  { ring: "ring-fuchsia-500/40", glow: "glow-magenta", grad: "from-fuchsia-500 to-pink-500" },
  { ring: "ring-violet-500/40", glow: "glow-purple", grad: "from-violet-500 to-indigo-500" },
];

export const Mission = () => {
  const { t } = useLang();
  const ref = useReveal();

  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-24 lg:py-32 reveal"
      ref={ref}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Kicker label={t.mission.kicker} />
          <h2
            className="font-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]"
            data-testid="mission-title"
          >
            {t.mission.title.split(" ").slice(0, -2).join(" ")}{" "}
            <span className="text-baj-grad">
              {t.mission.title.split(" ").slice(-2).join(" ")}
            </span>
          </h2>
          <p className="mt-6 text-lg text-slate-300 leading-relaxed">
            {t.mission.text}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {t.mission.values.map((v, i) => {
            const Icon = icons[i];
            const a = accents[i];
            return (
              <div
                key={v.title}
                className={`group relative glass rounded-3xl p-7 lg:p-8 hover:-translate-y-1.5 transition-transform duration-300 ${a.glow}`}
                data-testid={`mission-card-${i}`}
              >
                <div
                  className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${a.grad} flex items-center justify-center shadow-lg`}
                >
                  <Icon className="w-7 h-7 text-white" strokeWidth={2.5} />
                </div>
                <h3 className="font-display mt-5 text-2xl font-bold text-white">
                  {v.title}
                </h3>
                <p className="mt-3 text-slate-300 leading-relaxed">{v.text}</p>
                <div className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-slate-400">
                  <span>0{i + 1}</span>
                  <span className="h-px flex-1 bg-gradient-to-r from-white/20 to-transparent" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const Kicker = ({ label }) => (
  <div className="inline-flex items-center gap-2.5">
    <span className="block w-7 h-px bg-gradient-to-r from-fuchsia-400 to-orange-400" />
    <span className="text-[0.7rem] sm:text-xs font-bold uppercase tracking-[0.35em] text-fuchsia-200/80">
      {label}
    </span>
  </div>
);
